"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ramda = require("ramda");

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _gift = require("../Shapes/gift.shape");

var _constants = require("../constants");

var _constants2 = require("../CreateGift/constants");

var _GiftCard = _interopRequireDefault(require("./GiftCard"));

var _GiftHistoryStatus = _interopRequireDefault(require("./GiftHistoryStatus"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    createdStatus: {
      padding: "0 ".concat(spacing(6)),
      paddingBottom: spacing(3),
      textAlign: 'center'
    },
    descriptionTitle: {
      color: palette.grey.main,
      paddingTop: spacing(2),
      textTransform: 'uppercase',
      fontSize: '12px',
      fontWeight: 'bold'
    },
    description: {
      color: palette.grey.main
    },
    subDescription: {
      fontSize: 14
    },
    meetingDescription: {
      fontWeight: 'bold'
    },
    calendarIcon: {
      fontSize: '12px',
      marginBottom: '2px',
      marginRight: '4px'
    },
    paddingTop: {
      paddingTop: spacing(2)
    },
    dateSlots: {
      display: 'inline-flex !important',
      textAlign: 'left !important'
    },
    timeSlots: {
      display: 'inline-flex !important',
      textAlign: 'left !important',
      paddingLeft: 14
    }
  };
});

var GiftsHistoryListItem = function GiftsHistoryListItem(_ref2) {
  var gift = _ref2.gift,
      name = _ref2.name,
      email = _ref2.email,
      hideStatuses = _ref2.hideStatuses,
      canUseGiftCreateFlow = _ref2.canUseGiftCreateFlow,
      onViewGiftDetails = _ref2.onViewGiftDetails;
  var classes = useStyles();

  var _useState = (0, _react.useState)(hideStatuses),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isGiftStatusesClose = _useState2[0],
      setIsGiftStatusesClose = _useState2[1];

  var toggleStatuses = (0, _react.useCallback)(function () {
    setIsGiftStatusesClose(!isGiftStatusesClose);
  }, [isGiftStatusesClose]);
  var onViewGiftDetailsHandler = (0, _react.useCallback)(function () {
    return onViewGiftDetails(gift);
  }, [onViewGiftDetails, gift]);
  var renderViewGiftDetails = (0, _react.useCallback)(function () {
    if (canUseGiftCreateFlow) {
      return /*#__PURE__*/_react.default.createElement(_material.Box, {
        className: "Subcopy-Regular-Link Text-Pointer",
        mt: 2,
        mb: 1,
        onClick: onViewGiftDetailsHandler
      }, "View gift details");
    }

    return null;
  }, [canUseGiftCreateFlow, onViewGiftDetailsHandler]);
  var renderMeetingNotes = (0, _react.useCallback)(function () {
    if (gift.meetingNotes) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.Divider, {
        mt: 2,
        mb: 2
      }), /*#__PURE__*/_react.default.createElement(_material.Box, {
        mb: 1
      }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
        className: "Body-Regular-Left-Static-Bold"
      }, name, "'s meeting notes:")), /*#__PURE__*/_react.default.createElement(_material.Typography, null, gift.meetingNotes), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
        mt: 2
      }));
    }

    return null;
  }, [gift, name]);
  var renderShippingInfo = (0, _react.useCallback)(function (description) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: classes.descriptionTitle
    }, "delivery method"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: classes.description
    }, description), !(0, _ramda.isEmpty)(gift.shippingInfo) && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
      mt: 2
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: classes.description
    }, "Tracking number:")), /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: classes.description
    }, gift.shippingInfo.tracking_carrier, ": ", gift.shippingInfo.tracking_number)), gift.statusId < 40 && /*#__PURE__*/_react.default.createElement(_material.Link, {
      href: gift.shippingInfo.tracking_link,
      target: "_blank"
    }, ' ', "Track")), renderViewGiftDetails());
  }, [classes, gift, renderViewGiftDetails]);
  var renderMeetingInfo = (0, _react.useCallback)(function (description) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: (0, _classnames.default)(classes.description, classes.paddingTop)
    }, description), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: (0, _classnames.default)(classes.meetingDescription, classes.paddingTop)
    }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "calendar-alt",
      color: "primary",
      className: classes.calendarIcon
    }), ' ', (0, _moment.default)(gift.meeting.start).local().format(_constants.USER_FULL_TEXT_DATE_FORMAT)), renderMeetingNotes(), renderViewGiftDetails());
  }, [classes, gift, renderViewGiftDetails, renderMeetingNotes]);
  var renderMeetingTimeAvailableInfo = (0, _react.useCallback)(function (description) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: (0, _classnames.default)(classes.description, classes.paddingTop)
    }, description), gift.free_meetings.map(function (meeting) {
      return /*#__PURE__*/_react.default.createElement(_material.Typography, {
        className: (0, _classnames.default)(classes.meetingDescription, classes.paddingTop)
      }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
        icon: "calendar-alt",
        color: "primary",
        className: classes.calendarIcon
      }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
        component: "span",
        className: (0, _classnames.default)('Body-Regular-Center-Static-Bold', classes.dateSlots)
      }, (0, _moment.default)(meeting.start).local().format('dddd, MMMM DD, YYYY')), /*#__PURE__*/_react.default.createElement(_material.Typography, {
        component: "span",
        className: (0, _classnames.default)('Body-Regular-Center-Static', classes.timeSlots)
      }, "@", (0, _moment.default)(meeting.start).local().format('h:mm A'), "-", (0, _moment.default)(meeting.end).local().format('h:mm A')));
    }), renderMeetingNotes(), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: (0, _classnames.default)(classes.description, classes.paddingTop, classes.subDescription)
    }, "Reach out to them to confirm a meeting date."), /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      justifyContent: "space-between"
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: "Subcopy-Regular-Link Text-Pointer",
      mt: 2,
      mb: 1
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "mailto:".concat(email)
    }, "Email ", name)), canUseGiftCreateFlow && /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: "Subcopy-Regular-Link Text-Pointer",
      mt: 2,
      mb: 1,
      onClick: onViewGiftDetailsHandler
    }, "View gift details")));
  }, [classes, gift, onViewGiftDetailsHandler, name, email, canUseGiftCreateFlow, renderMeetingNotes]);
  var renderStatus = (0, _react.useCallback)(function (status) {
    if (status.label === 'Invite in transit' && gift.shippingInfo) {
      return renderShippingInfo(status.status_string);
    }

    if (status.label === 'Meeting booked' && gift.meeting) {
      return renderMeetingInfo(status.status_string);
    }

    if (status.label === 'Meeting times available' && gift.free_meetings) {
      return renderMeetingTimeAvailableInfo(status.status_string);
    }

    if (status.label === 'Options ready' && canUseGiftCreateFlow && gift.statusId === _constants2.giftStatuses.PRODUCTS_PROPOSED) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
        className: (0, _classnames.default)(classes.description, status.status_string ? classes.paddingTop : '')
      }, status.status_string), /*#__PURE__*/_react.default.createElement(_material.Box, {
        mt: 2,
        width: 1,
        mb: 2
      }, /*#__PURE__*/_react.default.createElement(_material.Button, {
        fullWidth: true,
        variant: "contained",
        color: "secondary",
        onClick: onViewGiftDetailsHandler
      }, "View gift options!")));
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: (0, _classnames.default)(classes.description, status.status_string ? classes.paddingTop : '')
    }, status.status_string), renderViewGiftDetails());
  }, [gift, canUseGiftCreateFlow, classes, renderViewGiftDetails, renderShippingInfo, renderMeetingInfo, renderMeetingTimeAvailableInfo, onViewGiftDetailsHandler]);
  var showResearchMessage = (0, _react.useMemo)(function () {
    return gift.history.length === 1;
  }, [gift]);
  var showStatusList = (0, _react.useMemo)(function () {
    return gift.history.length > 1;
  }, [gift]);
  var lastGiftIndex = (0, _react.useMemo)(function () {
    return gift.history.length - 1;
  }, [gift]);
  var createAt = (0, _react.useMemo)(function () {
    var _getLastEvent;

    var getLastEvent = (0, _ramda.pipe)((0, _ramda.sort)(function (historyItem) {
      return new Date(historyItem.action_date).getTime();
    }), _ramda.last);
    return ((_getLastEvent = getLastEvent(gift.history)) === null || _getLastEvent === void 0 ? void 0 : _getLastEvent.action_date) || null;
  }, [gift]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, null, /*#__PURE__*/_react.default.createElement(_GiftCard.default, {
    statusId: gift.statusId,
    product: gift.product,
    campaign: gift.campaign && gift.campaign.name,
    sentBy: gift.sentBy,
    sentAs: gift.sentAs,
    createdAt: createAt,
    isShowStatuses: !isGiftStatusesClose,
    onClick: function onClick() {
      return toggleStatuses(!isGiftStatusesClose);
    },
    shippingInfo: gift.shippingInfo
  }), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: !isGiftStatusesClose
  }, showResearchMessage && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.createdStatus
  }, "Alyce is currently researching gift options for ".concat(name, "... we\u2019ll get back to you soon!")), showStatusList && gift.history.map(function (status, index) {
    return /*#__PURE__*/_react.default.createElement(_GiftHistoryStatus.default, {
      primary: index === 0,
      key: status.label,
      date: status.action_date,
      title: status.label,
      description: renderStatus(status),
      useDots: index < lastGiftIndex,
      isOneOffGift: !gift.campaign
    });
  })));
};

GiftsHistoryListItem.propTypes = {
  gift: _gift.giftShape.isRequired,
  name: _propTypes.default.string.isRequired,
  email: _propTypes.default.string.isRequired,
  hideStatuses: _propTypes.default.bool,
  canUseGiftCreateFlow: _propTypes.default.bool,
  onViewGiftDetails: _propTypes.default.func
};
GiftsHistoryListItem.defaultProps = {
  hideStatuses: false,
  canUseGiftCreateFlow: false,
  onViewGiftDetails: function onViewGiftDetails() {}
};
var _default = GiftsHistoryListItem;
exports.default = _default;